import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=793535fe"
import script from "./Menu.js?vue&type=script&lang=js&external"
export * from "./Menu.js?vue&type=script&lang=js&external"
import style0 from "./Menu.vue?vue&type=style&index=0&id=793535fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports